import { createFileRoute } from "@tanstack/react-router";
import { Header, Footer } from "@/components/site-chrome";
import { InstagramFeed } from "@/components/ui/instagram-feed";
import { useReveal } from "@/hooks/use-reveal";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About - Mr. Pizza Steve Finds" },
      { name: "description", content: "The story behind Mr. Pizza Steve Finds - Steve dos Santos vintage shop in Zamalek, Cairo." },
    ],
  }),
  component: About,
});

function About() {
  const mapRef = useReveal();
  const cardsRef = useReveal();
  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-background text-foreground">
      <Header />

      <div className="relative w-full overflow-hidden" style={{ height: "55vh" }}>
        <img
          src="https://res.cloudinary.com/dnggmrgmu/image/upload/w_900,f_auto,q_auto/v1783264947/about_snkv6q.jpg"
          alt="Mr. Pizza Steve market stand"
          loading="lazy"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background" />
      </div>

      <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
        <h1 className="text-3xl sm:text-5xl leading-tight animate-fade-slide-up" style={{ fontFamily: '"Inter Tight", system-ui, sans-serif', fontWeight: 300, letterSpacing: '-0.025em' }}>
          Pizza is your gateway for true vintage culture.
        </h1>

        <div className="mt-10 grid gap-8 text-sm leading-relaxed text-muted-foreground sm:grid-cols-[2fr_1fr]">
          <div className="space-y-5">
            <p style={{ fontFamily: '"Inter Tight", system-ui, sans-serif', fontWeight: 300, letterSpacing: '-0.025em' }}>
              Pop in between 3pm and 11pm or slide into DMs for inquiries. New drops always post at the same time, whether on the website or the Instagram page — stay updated or it's your loss.
            </p>
            <a
              href="https://instagram.com/mr.pizzastevefinds"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 border border-foreground px-5 py-3 text-[11px] uppercase tracking-[0.2em] text-foreground hover:bg-foreground hover:text-background transition-all active:scale-[0.98]"
            >
              Follow @mr.pizzastevefinds
            </a>
          </div>
          <aside className="border border-border p-6 h-fit">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Where are we</p>
            <p className="mt-3 text-base uppercase tracking-[-0.01em] text-foreground leading-tight">
              30 Hassan Assem St<br />Zamalek, Cairo
            </p>
            <p className="mt-3 text-xs">Daily · 3pm – 11pm</p>
          </aside>
        </div>

        <div ref={mapRef} className="reveal mt-12 overflow-hidden border border-border">
          <iframe
            title="Mr. Pizza Steve Finds location"
            src="https://www.google.com/maps?q=30+Hassan+Assem+St,+Zamalek,+Cairo&output=embed"
            width="100%"
            height="380"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="block w-full grayscale"
          />
        </div>

        <div ref={cardsRef} className="reveal mt-12 grid gap-px bg-border sm:grid-cols-2">
          <div className="bg-background p-6">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Come Visit</p>
            <p className="mt-3 text-base uppercase tracking-[-0.01em] text-foreground leading-tight">
              30 Hassan Assem St<br />Zamalek, Cairo
            </p>
            <p className="mt-3 text-xs text-muted-foreground">Daily · 3pm – 11pm</p>
          </div>
          <div className="bg-background p-6">
            <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Slide Into the DMs</p>
            <p className="mt-3 text-xs text-muted-foreground leading-relaxed">
              Got a question about a piece? Want to hold something before someone else snatches it? Just DM us.
            </p>
            <a
              href="https://ig.me/m/mr.pizzastevefinds"
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-block border border-foreground px-5 py-2.5 text-[10px] uppercase tracking-[0.2em] text-foreground hover:bg-foreground hover:text-background transition-all active:scale-[0.98]"
            >
              Instagram DM
            </a>
          </div>
        </div>
      </section>

      <InstagramFeed />
      <Footer />
    </div>
  );
}
